[
  {
    "id": "SWW-B8-L301-001",
    "module": "SpellingWW",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "question": "De ... aardappelen (poten).",
    "options": ["gepote", "gepotte", "gepootte", "gepoot"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bnvd_meervoud",
    "familyId": "SWW-BNVD-E-MEERVOUD",
    "conceptId": "bnvd_plural_e_and_open_syllable_spelling",
    "variantIndex": 1,
    "explanation": "Je beschrijft de aardappelen, dus je gebruikt het bijvoeglijk gebruikte voltooid deelwoord.\nVoltooid deelwoord van 'poten' is 'gepoot'.\nBij meervoud komt er meestal een -e achter: 'gepoot' → 'gepote'.\nSpellingtip: in 'ge-po-te' staat de o in een open lettergreep, daarom schrijf je één o.",
    "distractorExplanations": {
      "1": "Hier maak je een dubbele t, maar je hoort geen dubbele medeklinker. Bovendien blijft de klank in 'ge-po-te' gelijk, dus één t is genoeg.",
      "2": "Dit houdt 'oo' vast alsof het één lettergreep blijft, maar in 'ge-po-te' splits je het woord. Dan wordt het 'gepote' (één o) en geen 'gepootte'.",
      "3": "Dit is het voltooid deelwoord zonder -e. In 'De ... aardappelen' gebruik je het als bijvoeglijk woord, dus met -e: 'gepote'."
    }
  },
  {
    "id": "SWW-B8-L301-002",
    "module": "SpellingWW",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "question": "Hij ... de bal in het doel. (koppen)",
    "options": ["kopte", "kopde", "kopt", "gekopte"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_zwak_te_de",
    "familyId": "SWW-VT-ZWAK-TEDE-TKOF",
    "conceptId": "past_tense_weak_verb_te_rule",
    "variantIndex": 1,
    "explanation": "Dit is verleden tijd.\nStam van 'koppen' is 'kop'.\nBij zwakke werkwoorden is de verleden tijd: stam + te/de.\nDe stam eindigt op p (zit in 't kofschip), dus je kiest 'te': kop + te = kopte.",
    "distractorExplanations": {
      "1": "Je kiest 'de' terwijl p in 't kofschip zit. Dan hoort het 'te' te zijn: kopte.",
      "2": "Dit is tegenwoordige tijd. De vraag gaat om verleden tijd, dus kopte.",
      "3": "Dit is geen juiste vorm als persoonsvorm in een gewone zin. Het voltooid deelwoord is 'gekopt' en gebruik je met 'heeft': 'Hij heeft gekopt'."
    }
  },
  {
    "id": "SWW-B8-L301-003",
    "module": "SpellingWW",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "question": "Het schip is ... (stranden).",
    "options": ["gestrand", "gestrandt", "gestrande", "strandde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_zwak_d_of_t",
    "familyId": "SWW-VD-ZWAK-DT-KEUZE",
    "conceptId": "past_participle_weak_verb_d_or_t",
    "variantIndex": 1,
    "explanation": "Na 'is' hoort een voltooid deelwoord.\nHele werkwoord: stranden. Stam: strand.\nLaatste letter van de stam is d (niet in 't kofschip), dus het voltooid deelwoord eindigt op d.\nJe schrijft geen extra d: gestrand.",
    "distractorExplanations": {
      "1": "Een voltooid deelwoord eindigt op d of t, maar niet op 'dt'. 'Dt' hoort bij persoonsvormen (zoals 'hij strandt').",
      "2": "Dit is de bijvoeglijke vorm (zoals in 'het gestrande schip'). In 'Het schip is ...' vul je het voltooid deelwoord in: gestrand.",
      "3": "Dit is verleden tijd. In de zin met 'is' gebruik je voltooid deelwoord: is gestrand."
    }
  },
  {
    "id": "SWW-B8-L301-004",
    "module": "SpellingWW",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "question": "Jij ... gisteren. (verhuizen)",
    "options": ["verhuisde", "verhuiste", "verhuist", "verhuisd"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_zwak_zs_vf",
    "familyId": "SWW-VT-ZS-VF-KIJK_HEEL_WW",
    "conceptId": "past_tense_zs_vf_check_full_infinitive",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' weet je: verleden tijd.\nStam lijkt 'verhuis' te zijn, maar bij z/s en v/f kijk je naar het hele werkwoord.\nHet hele werkwoord is 'verhuizen' (eindigt op z-klank).\nZ zit niet in 't kofschip, dus je kiest 'de': verhuis + de = verhuisde.",
    "distractorExplanations": {
      "1": "Je kijkt hier naar de s van de stam, maar bij 'verhuizen' hoort de z-klank van het hele werkwoord. Daarom is het 'de' en niet 'te'.",
      "2": "Dit is tegenwoordige tijd. Door 'gisteren' heb je verleden tijd nodig: verhuisde.",
      "3": "Dit is het voltooid deelwoord ('verhuisd') en gebruik je met 'bent/hebt': 'Jij bent verhuisd'. Hier moet de persoonsvorm in verleden tijd staan: verhuisde."
    }
  },
  {
    "id": "SWW-B8-L301-005",
    "module": "SpellingWW",
    "difficulty": 301,
    "difficultyTier": 13,
    "levelCode": "B8",
    "group": 8,
    "question": "De ... ramen (lappen).",
    "options": ["gelapte", "gelapde", "gelapt", "lapte"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bnvd_meervoud",
    "familyId": "SWW-BNVD-E-MEERVOUD",
    "conceptId": "bnvd_plural_e_from_past_participle",
    "variantIndex": 2,
    "explanation": "Je beschrijft 'de ramen' (meervoud), dus je gebruikt het bijvoeglijk gebruikte voltooid deelwoord.\nVoltooid deelwoord van 'lappen' is 'gelapt' (p zit in 't kofschip, dus t).\nBij meervoud komt er meestal een -e bij: gelapt → gelapte.",
    "distractorExplanations": {
      "1": "Dit zou alleen kunnen als het voltooid deelwoord op d eindigde, maar bij 'lap' hoort juist t: gelapt.",
      "2": "Dit is het voltooid deelwoord zonder -e. In 'De ... ramen' hoort de bijvoeglijke vorm met -e: gelapte.",
      "3": "Dit is verleden tijd. Je beschrijft ramen (welke ramen?), dus bijvoeglijk: gelapte ramen."
    }
  }
]
